import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IGqlBaseOptions } from 'src/app/shared/modules/graphql/interfaces';
import { ListPage } from 'src/app/shared/helpers/list-page.class';
import { IApiInvestigationTimelogConnection, IApiInvestigationMetricsFilter } from 'src/app/shared/modules/graphql/types/types';
import { GqlInvestigationTimelogService } from 'src/app/shared/modules/graphql/services/reports';


@Injectable()
export class InvestigationTimelogService {
  constructor(
    private reports: GqlInvestigationTimelogService
  ) { }

  public get(filters?: IApiInvestigationMetricsFilter[], options?: IGqlBaseOptions): Observable<IApiInvestigationTimelogConnection> {
    return this.reports.get(filters, options || new ListPage());
  }

}
